import React from 'react';
import '../style/ExpertiseStyles.css';

const Expertise = () => {
  return (
    <div className="expertise-container">
      <div className="expertise-content">
        <h2>Our Expertise & Passion</h2>
        <p>With over a decade of experience in nail artistry, our team of dedicated professionals 
        brings creativity and precision to every service. We believe in combining traditional 
        techniques with modern innovations to deliver exceptional results.</p>
        
        <div className="expertise-grid">
          <div className="expertise-item">
            <i className="fas fa-certificate"></i>
            <h3>Expert Technicians</h3>
            <p>Our nail artists are certified professionals with years of experience</p>
          </div>
          
          <div className="expertise-item">
            <i className="fas fa-spa"></i>
            <h3>Premium Products</h3>
            <p>We use only the highest quality, safe, and trusted products</p>
          </div>
          
          <div className="expertise-item">
            <i className="fas fa-heart"></i>
            <h3>Satisfaction Guaranteed</h3>
            <p>Your happiness is our priority - we ensure every visit exceeds expectations</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expertise;
